<template>
    <b-dropdown size="md" variant="link" class="mr-3 invisible-select">
        <template v-slot:button-content>
            <span class="color-gold">{{currentRealmName}}</span>
        </template>

        <b-dropdown-item v-for="(realm, index) in $t('components.after-login-realm-select.realms')"
                         :key="index" @click="selectRealm(realm.key)">
            <span :class="currentRealmKey === realm.key ? 'color-gold' : ''">{{realm.name}}</span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
    import RealmApiService from "../../api/realm.api";

    export default {
        name: "RealmSelect",
        methods: {
            selectRealm(realm) {
                if (realm !== this.currentRealmKey) {
                    this.errors = [];
                    this.$swal.fire({
                        icon: "question",
                        title: this.$t('confirm.title'),
                        html: this.$t("components.realm-select.warning-text"),
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonText: this.$t('confirm.yes'),
                        cancelButtonText: this.$t('confirm.cancel'),
                    })
                        .then(result => {
                            if (result.value) {
                                let loader = this.$loading.show();
                                RealmApiService.select(realm)
                                    .then(() => {
                                        location.reload(true);
                                    })
                                    .catch(error => {
                                        if (!error.response || error.response.data.message !== 'REALM_ERROR') {
                                            this.errors.push(this.$t('whoops'));
                                        } else {
                                            this.errors = error.response.data.payload.realm;
                                        }
                                    })
                                    .finally(() => {
                                        loader.hide();
                                        loader = null;
                                    });
                            }
                        });
                }
            }
        },
        computed: {
            currentRealmName() {
                let current = this.$store.getters['authStore/currentRealm'];
                if (!current) {
                    return 'N/A';
                }

                let realm = this.$t('components.after-login-realm-select.realms').find(item => item.key === current);
                return realm.name;
            },

            currentRealmKey() {
                return this.$store.getters['authStore/currentRealm'];
            },
        },
    }
</script>

<style scoped>

</style>
